'use strict'

import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default function (url, method, successCallback, errorCallback = null, defaultConfig = {}) {
  let config = {
    method,
    url,
    ...defaultConfig
  }

  let officialErrorCallback = (error) => {
    store.commit('decreaseLoading')

    if (typeof errorCallback === 'function') {
      errorCallback(error)
    }

    if (error.response) {
      let currentLocale = window.$i18n.locale
      let message = error.response.data.message ? error.response.data.message[currentLocale] : error.response.data.error
      message = `<div class="error">${message}</div>`
      store.commit('openNotification', { message, type: 'error' })

      if (error.response.status === 401) {
        store.commit('login/logout')
        router.push('/login')
      }
    } else if (error.request) {
      // console.log(error.request)
    } else {
      // console.log('Error', error.message)
    }

    return Promise.reject(error)
  }

  let officialSuccessCallback = (response) => {
    store.commit('decreaseLoading')
    successCallback(response)
  }

  store.commit('increaseLoading')

  return axios(config).then(
    (response) => officialSuccessCallback(response),
    (error) => officialErrorCallback(error)
  )
}
